/**
 * Валидаторы реквизитов компании. Все поля — только цифры фиксированной длины.
 * Возвращают `null` если значение валидно (или пустое — обязательность проверяется
 * отдельно), иначе текст ошибки на языке интерфейса.
 */
import i18n from '@/utils/i18n'

export function digitsOnly(s: string): string {
  return s.replace(/\D+/g, '')
}

function checkLen(value: string, label: string, ...lens: number[]): string | null {
  if (!value) return null
  if (!/^\d+$/.test(value)) return i18n.t('validate.digitsOnly', { label })
  if (!lens.includes(value.length)) {
    const count = lens.length === 1 ? `${lens[0]}` : lens.join(i18n.t('validate.or'))
    return i18n.t('validate.length', { label, count })
  }
  return null
}

export const validateInn = (v: string) => checkLen(v, i18n.t('validate.field.inn'), 10, 12)
export const validateKpp = (v: string) => checkLen(v, i18n.t('validate.field.kpp'), 9)
export const validateOgrn = (v: string) => checkLen(v, i18n.t('validate.field.ogrn'), 13)
export const validateBik = (v: string) => checkLen(v, i18n.t('validate.field.bik'), 9)
export const validateBankAccount = (v: string) => checkLen(v, i18n.t('validate.field.bankAccount'), 20)
export const validateCorrAccount = (v: string) => checkLen(v, i18n.t('validate.field.corrAccount'), 20)
